import { useState } from "react";
import { Modal } from "antd";
import Confirmed from "../../assets/icons/Confirmed";
import DashboardHeader from "../../components/DashboardHeader/DashboardHeader";

const ClassSchedulingConfirmation = () => {
  const [confirmVisible] = useState(true);

  const handleCancel = () => {
    window.location.replace("/");
  };
  return (
    <>
      <DashboardHeader />
      <Modal
        width={606}
        visible={confirmVisible}
        onOk={handleCancel}
        onCancel={handleCancel}
        footer={null}
      >
        <div style={{ padding: "40px" }}>
          <div className="modal-head" style={{ marginBottom: "32px" }}>
            <div className="confirm-icon-wrapper">
              <Confirmed />
            </div>
            <h2>Class booked!</h2>
            <p>You have successfully booked a live class with The Tutor</p>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ClassSchedulingConfirmation;
